
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
import ListaMarca from "./ListaMarca";
export default function MarcaForm() {
    return(
        <AlertDialogOnClose nome={"Marca"} placeholder={"Insira o nome da marca"}>
        	<ListaMarca />
        </AlertDialogOnClose>
    )
} 